// Ensure polyfill applies even if browser exposes partial native support
// window.__forceSmoothScrollPolyfill__ = true;

// Polyfills & vendor libraries
import smoothscroll from "smoothscroll-polyfill";
smoothscroll.polyfill();
// import "lazysizes";
import "./default";
import "./splash";
import "./product-panel";
import "./product-gallery";
import "./product-qty";
